<template>
 <div class="article-card-base" :class="{large: isLarge, affinity: isAffinity}">
   <template v-if="isAffinity">
     <div class="affinity-banner" :class="{ disable: campaignStat === '202002' }" @click="onAffinityBannerClick"><img src="/static/img/yearluck/y2020/affinity_banner.svg"></div>
   </template>

   <template v-else>
     <article-card-header :article-title="articleTitle" :target-id="targetId" />
     <div class="image"><img :src="imagePath" /></div>
     <div class="description">{{ description }}</div>
     <div class="detail-btn-wrap">
       <div class="detail-btn" :class="{ disable: campaignStat === '202002' && targetId < 297 }" @click="onDetailBtnClick">全てみる</div>
     </div>
   </template>
 </div>
</template>

<script>
import articleCardHeader from './articleCardHeader'
export default {
  name: "ArticleCard",
  components: { articleCardHeader },
  data() {
    return {
      isAffinity: false
    }
  },
  props: {
    campaignStat: {
      type: String,
      default() {
        return ''
      }
    },
    tgtItem: {
      type: Object,
      default() {
        return {}
      }
    },
    idx: {
      type: Number,
      default() {
        return 0
      }
    },
    isLarge: {
      type: Boolean,
      default() {
        return false
      }
    },
    group: {
      type: String,
      default() {
        return ''
      }
    },
    tgtBirthday: {
      type: String,
      default() {
        return ''
      }
    }
  },
  mounted() {
    this.isAffinity = (parseInt(this.targetId) === 295 || parseInt(this.targetId) === 296 ) && this.tgtBirthday.length <= 0
  },
  computed: {
    imagePath() {
      return this.tgtItem.imageUrl
    },
    articleTitle() {
      return this.tgtItem.title
    },
    description() {
      return this.tgtItem.summary
    },
    targetId() {
      return this.tgtItem.textItemId
    },
  },
  methods: {
    onDetailBtnClick() {
      this.$emit('detailBtnClick', this.idx, this.group)
    },
    onAffinityBannerClick() {
      this.$emit('detailBtnClick', this.idx, 'affinity' )
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/variables/index";
.article-card-base {
  $imgW: 135px;
  $imgWs: 120px;
  $outerPaddingH: 25px;
  $outerPaddingV: 12px;
  $imgMargin: 20px;
  $imgMarginS: 12px;

  width: 100%;
  min-height: $imgW + $outerPaddingV + $outerPaddingV;
  padding: $outerPaddingV 0 $outerPaddingV ($imgWs + $imgMarginS);
  position: relative;
  color: $gray-20;
  @include mq('w320'){
    padding: $outerPaddingV 0 $outerPaddingV ($imgW + $imgMargin);
  }
  @include mq () {
    padding: $outerPaddingV 0 $outerPaddingV ($imgW + $imgMargin);
    .image {
      left: 8px;
    }
  }
  .image {
    width: $imgWs;
    height: $imgWs;
    position: absolute;
    top: $outerPaddingV;
    left: 0;
    border-radius: 5px;
    overflow: hidden;
    @include mq('w320') {
      width: $imgW;
      height: $imgW;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .description {
    font-size: 12px;
    line-height: 19px;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    /* autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    overflow: hidden;
  }
  .detail-btn-wrap {
    width: 100%;
    text-align: right;
    display: inline-block;
    position: absolute;
    bottom: 12px;
    right: 0;
    @include mq() {
      right: 8px;
    }


    .detail-btn {
      display: inline-block;
      color: $brown-10;
      font-weight: bold;
      font-size: 12px;
      user-select: none;
      cursor: pointer;
      &::after {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        background: url('/static/img/yearluck/y2020/next_white.svg') no-repeat center center $brown-10;
        border-radius: 15px;
        margin-bottom: 2px;
        margin-left: 6px;
        vertical-align: middle;
      }
      &.disable {
        filter: grayscale(1) brightness(2.185); //#e4e4e4になるはず
      }
    }
  }
  &.large {
    padding: 0 0 12px;
    /deep/ .article-title-header-base {
      margin-bottom: 16px;
    }
    .image {
      width: 100%;
      height: auto;
      position: static;
      margin-bottom: 16px;
    }
    .description {
      margin-bottom: 30px;
    }
  }
  &.affinity {
    padding: $outerPaddingV 0;
    min-height: auto;
    .affinity-banner {
      img {
        display: block;
        width: 100%;
        height: auto;
      }
      &.disable {
        filter: grayscale(1) brightness(1.2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/articleCard.vue